var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.priceIndicatorText)?_c('span',[_c('status-dot',{staticStyle:{"display":"inline-block","padding-right":"5px"},attrs:{"value":_vm.priceIndicatorColour}}),_vm._v("\n        "+_vm._s(_vm.priceIndicatorText)+"\n    ")],1):_c('span',[_vm._v("-")])])
}
var staticRenderFns = []

export { render, staticRenderFns }